module.exports = __webpack_public_path__ + "media/images/icon-menu-527cf6b943304e73434f2d4250f95d60.svg";